import createReducer from "../../../../app/common/util/reducerUtil";
import {
  CREATE_USER_ACCOUNT,
  ACCOUNT_LOADING,
  RESET_ACCOUNT_MESSAGE
} from "./accountConstants";

// Copyright 2019 Bik_krl
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

const initialState = {
  message: "",
  loading: false,
  user: {}
};

export const createUserAccount = (state, payload) => {
  return { ...state, message: payload, loading: false };
};

export const isLoading = (state, payload) => {
  return { ...state, loading: payload };
};

export const resetAccountMessage = (state, payload) => {
  return { ...state, message: payload };
};

export default createReducer(initialState, {
  [CREATE_USER_ACCOUNT]: createUserAccount,
  [ACCOUNT_LOADING]: isLoading,
  [RESET_ACCOUNT_MESSAGE]: resetAccountMessage
});
